import { connect } from 'react-redux';
import Search from 'components/search/Search';
import {
  clearSearch,
  search,
  selectErrorMessage,
  selectIsSearchActive,
  selectIsSearching,
  selectRadius,
  selectZipcode,
  updateRadius,
  updateZipcode,
} from '../modules/search';

export default connect(
  state => ({
    errorMessage: selectErrorMessage(state),
    radius: selectRadius(state),
    zipcode: selectZipcode(state),
    isLoading: selectIsSearching(state),
    isActive: selectIsSearchActive(state),
  }),
  { clearSearch, updateRadius, updateZipcode, search },
)(Search);
